function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 21.2h391.305C451.335 21.2 500 69.82 500 129.796v283.406c0 59.977-48.664 108.598-108.695 108.598h-282.61C48.665 521.8 0 473.18 0 413.203zm70.54 63.034V415c0 23.992 19.468 43.441 43.48 43.441h272.406c24.012 0 43.48-19.449 43.48-43.441V127.672c0-23.988-19.469-43.438-43.48-43.438zm75.991 0h70.078v252.653c0 23.992-19.464 43.441-43.48 43.441H70.539V319.27h75.992zm0 0h70.078zM70.54 380.328V319.27zm283.371 78.113h-70.074V205.79c0-23.992 19.465-43.441 43.476-43.441h102.594v61.058H353.91zm75.996-296.093v61.058zM353.91 458.44h-70.074zm0 0",
  fillRule: "evenodd",
  fill: "#3964df"
});

function SvgSquarelink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 500,
    height: 724,
    viewBox: "0 0 500 543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquarelink);
export default __webpack_public_path__ + "static/media/squarelink.aa738a95.svg";
export { ForwardRef as ReactComponent };